export default __webpack_public_path__ + "static/media/gear_animated.27306c55.gif";